import FormattedMessage from 'I18n/components/FormattedMessage';
import useCrmObjectName from 'marketing-platform-lib/hooks/useCrmObjectName';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import ErrorMessage from 'framework-asset-preview-lib/internal/shared/components/ErrorMessage';
import { lowerCase } from 'framework-asset-preview-lib/internal/shared/utils/assetPreview';
import AssociatedAsset from './AssociatedAsset';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function AssociatedAssets({
  associatedObjects,
  associationGroup,
  crmObject,
  hoverAssetId,
  isEmptyState,
  isError,
  isLoading,
  onHoverAsset,
  properties
}) {
  const {
    objectTypeNameSingular
  } = useCrmObjectName(crmObject.objectTypeId);
  if (isLoading) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'relative',
        minHeight: 120
      },
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        previewType: "sidepanel"
      })
    });
  }
  if (isError) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      errorType: "ASSOCIATED_OBJECTS",
      objectId: crmObject.objectId,
      objectType: crmObject.objectTypeId
    });
  }
  if (isEmptyState) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkAssetPreviewLib.tabs.assets.assetsSection.noResults",
      options: {
        assetName: lowerCase(associationGroup.objectTypeName),
        objectType: objectTypeNameSingular
      }
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: associatedObjects.map(associatedObject => /*#__PURE__*/_jsx(AssociatedAsset, {
      associatedObject: associatedObject,
      associationGroup: associationGroup,
      crmObject: crmObject,
      onHoverAsset: onHoverAsset,
      openPopover: hoverAssetId === associatedObject.objectId,
      properties: properties
    }, associatedObject.objectId))
  });
}